import { render, staticRenderFns } from "./System.vue?vue&type=template&id=7e7b83f8&scoped=true&"
import script from "./System.vue?vue&type=script&lang=js&"
export * from "./System.vue?vue&type=script&lang=js&"
import style0 from "./System.vue?vue&type=style&index=0&id=7e7b83f8&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e7b83f8",
  null
  
)

export default component.exports